var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconScmpShorts = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1407 10L8.24214 5.50786V14.4921L14.1407 10ZM20 10C20 12.76 19.0236 15.1171 17.0707 17.07C15.1171 19.0236 12.76 20 10 20C7.24 20 4.88286 19.0236 2.93 17.07C0.976429 15.1171 0 12.76 0 10C0 7.24 0.976429 4.88286 2.93 2.93C4.88286 0.976429 7.24 0 10 0C12.76 0 15.1171 0.976429 17.0707 2.93C19.0236 4.88286 20 7.24 20 10Z",
  fill: "#333333"
})));
export default SvgIconScmpShorts;